import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from 'react';
import { TStorageItemRS } from '../models/storageModel';
import { TModuleOptions } from '../models/salesModel';

export type TStorage = {
  displayOptions: TModuleOptions[],
  categoryOptions: TModuleOptions[],
  taxesOptions: TModuleOptions[],
  paymentOptions: TModuleOptions[],
  itemTypes: TModuleOptions[],
  umOptions: TModuleOptions[],
  creditNoteOptions: TModuleOptions[],
  debitNoteOptions: TModuleOptions[],
  registerList: TStorageItemRS[]
  storageViewType: "TABLE" | "LIST"
}
const initialState:TStorage = {
  registerList: [],
  storageViewType: "TABLE",
  displayOptions: [],
  categoryOptions: [],
  taxesOptions: [],
  paymentOptions: [],
  itemTypes: [],
  umOptions: [],
  creditNoteOptions: [],
  debitNoteOptions: []
}
interface RegisterContextType {
  register: TStorage;
  updateRegister: (newConfig: Partial<TStorage>) => void;
}
interface RegisterProviderProps {
  children: ReactNode;
}
const RegisterContext = createContext<RegisterContextType>({register:initialState,updateRegister:()=>{}});

export const RegisterProvider:React.FC<RegisterProviderProps> = ({ children }) => {
  const [register, setRegister] = useState(initialState);
  const updateRegister = useCallback((newConfig:Partial<TStorage>) => {
    setRegister((prevConfig) => ({ ...prevConfig, ...newConfig }));
  }, []);

  const contextValue = useMemo(() => ({
    register,
    updateRegister,
  }), [register, updateRegister]);

  return (
    <RegisterContext.Provider value={contextValue}>
      {children}
    </RegisterContext.Provider>
  );
};

export const useRegister = () => {
  return useContext(RegisterContext);
};